import React, { useState, useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { get, map } from 'lodash';
import { RootState } from 'modules';
import scrollIntoView from 'scroll-into-view';
import MentoringClassStatus from 'components/mentoring/MentoringClassStatus';
import MentoringReviewModal from 'components/mentoring/MentoringReviewModal';
import { getPastMentoringClasses } from 'libs/api/mentoring';
import { useDataApi, usePagination } from 'libs/hooks';
import { TMentoringClass } from 'modules/mentoring';
import { TListResponse, TPagination, TModalState } from 'modules/types';
import { CUserType } from 'constants/user.const';
import { EUserType } from 'enums/base.enum';
import { ERoute } from 'enums/route.enum';
import { Tooltip, Avatar, Button, Col, Row, Typography, Divider, Spin, List, BackTop } from 'antd';
import { StarOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;
type TMenteePastClassProps = {
  withId?: number;
  targetType: EUserType;
  useDivider?: boolean;
  useProfile?: boolean;
};
const MentoringPastClass = ({
  withId = 0,
  targetType,
  useDivider = false,
  useProfile = true,
}: TMenteePastClassProps) => {
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const [pagination, setPagination] = usePagination(4);
  const [mentoringClasses, setMentoringClasses] = useState<Array<TMentoringClass>>([]);
  const reloadPage = (page?: Partial<TPagination>) => {
    setPagination({
      ...pagination,
      ...page,
    });
  };

  // console.log("withId",withId);

  const getPromise = getPastMentoringClasses.bind(null, withId, {
    params: {
      current: pagination.current,
      pageSize: pagination.pageSize,
      mentoringField: currentUser?.primary_field,
    },
  });
  const [{ data, loading }, setCallback] = useDataApi<TListResponse<TMentoringClass>>(getPromise, {
    contents: [],
    last: false,
  });
  const [mentoringReviewModal, setMentoringReviewModal] = useState<TModalState>({
    visible: false,
  });

  useEffect(() => {
    setCallback(() => getPromise);
  }, [pagination]);

  useEffect(() => {
    if (!loading) {
      (async () => {
        await setMentoringClasses([...mentoringClasses, ...get(data, 'contents')]);
        if (get(pagination, 'current', 1) > 1) {
          const newElementIndex = (get(pagination, 'current', 1) - 1) * get(pagination, 'pageSize', 0);
          const elem = document?.getElementById(`past-schedule-${newElementIndex}`) as HTMLElement;
          scrollIntoView(elem, {
            align: {
              top: 0.3,
            },
          });
        }
      })();
    }
  }, [loading]);

  return (
    <>
      <div>
        <Spin tip='loading...' spinning={loading} delay={1000}>
          <List
            itemLayout='horizontal'
            dataSource={mentoringClasses}
            renderItem={(mentoring_class: TMentoringClass, index: number) => (
              <>
                <Row justify='space-between' align='middle' gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={24} lg={14} xl={14}>
                    <MentoringClassStatus record={mentoring_class} id={`past-schedule-${index}`} />
                    {useProfile === true && (
                      <Link
                        className='small-profile'
                        to={
                          targetType === EUserType.Mentor
                            ? `${ERoute.MentoringMentorView.replace(
                                ':record_id',
                                String(get(mentoring_class, `${targetType}.id`)),
                              )}`
                            : `${ERoute.MentoringMenteeView.replace(
                                ':record_id',
                                String(get(mentoring_class, `${targetType}.id`)),
                              )}`
                        }
                      >
                        <Avatar src={get(mentoring_class, `${targetType}.user.profile_image.absolute_url`)} />
                        <span>
                          {get(mentoring_class, `${targetType}.user.fullname`)} {CUserType[targetType]}
                        </span>
                      </Link>
                    )}
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={10} xl={10}>
                    {targetType === EUserType.Mentor ? (
                      <Row gutter={[8, 8]} justify='end'>
                        {/* 멘티 입장에서 보이는 버튼 */}
                        {get(mentoring_class, 'is_attended') === true && (
                          <Col>
                            {get(mentoring_class, 'review') ? (
                              <Link to={`${ERoute.MentoringReview}/view/?id=${mentoring_class.id}&review_id=${mentoring_class.review}`}>
                                <Button
                                  /*onClick={() => {
                                    setMentoringReviewModal({
                                      visible: true,
                                      isView: true,
                                      record: mentoring_class,
                                    });
                                  }}*/
                                >
                                  멘티 피드백
                                </Button>
                              </Link>
                            ) : (
                              <Link to={`${ERoute.MentoringReview}/create/?id=${mentoring_class.id}`}>
                                <Button type='primary' style={{ marginRight: '5px' }}>
                                멘토 평가하기
                                </Button>
                              </Link>
                              /*<Button
                                type='primary'
                                onClick={() => {
                                  setMentoringReviewModal({
                                    visible: true,
                                    record: mentoring_class,
                                    onFinish: (review_id: number) => {
                                      const tempMentoringClasses = map(mentoringClasses, (v) => {
                                        if (v.id === mentoring_class.id) {
                                          v.review = review_id;

                                          return v;
                                        }
                                        return v;
                                      });
                                      setMentoringClasses(tempMentoringClasses);
                                    },
                                  });
                                }}
                              >
                                <StarOutlined />
                                멘토 평가하기
                              </Button>*/
                            )}
                          </Col>
                        )}
                        {get(mentoring_class, 'is_mentor_attended') === true && (
                          <Col>
                            {get(mentoring_class, 'is_feedback_completed') === true ? (
                              <>
                                {get(mentoring_class, 'review') ? (
                                  <Link
                                    to={`${ERoute.MentoringFeedback}/view/${get(
                                      mentoring_class,
                                      'feedback',
                                    )}`}
                                  >
                                    <Button>멘토 피드백</Button>
                                  </Link>
                                ) : (
                                  <Tooltip title='피드백을 보려면 멘토 평가를 완료해 주세요'>
                                    <Button className='btn-disabled'>멘토 피드백</Button>
                                  </Tooltip>
                                )}
                              </>
                            ) : (
                              <Tooltip title='피드백을 작성중입니다'>
                                <Button className='btn-disabled'>멘토 피드백</Button>
                              </Tooltip>
                            )}
                          </Col>
                        )}
                        <Col>
                          <Link
                            to={`${ERoute.MentoringClassView.replace(
                              ':record_id',
                              String(get(mentoring_class, 'id')),
                            )}`}
                          >
                            <Button>자세히 보기</Button>
                          </Link>
                        </Col>
                      </Row>
                    ) : (
                      <Row gutter={[8, 8]} justify='end'>
                        {/* 멘토 입장에서 보이는 버튼 */}
                        { /*get(mentoring_class, 'is_mentee_attended') === true && (
                          <Col>
                            {get(mentoring_class, 'review') ? (
                              <Button
                                onClick={() => {
                                  setMentoringReviewModal({
                                    visible: true,
                                    isView: true,
                                    record: mentoring_class,
                                  });
                                }}
                              >
                                멘티 피드백
                              </Button>
                            ) : (
                              <Button className='btn-disabled'>멘티 피드백</Button>
                            )}
                          </Col>
                          )*/ }
                        {get(mentoring_class, 'is_attended') === true && (
                          <Col>
                            {get(mentoring_class, 'is_feedback_completed') === true ? (
                              <Link
                                to={`${ERoute.MentoringFeedback}/view/${get(mentoring_class, 'feedback')}`}
                              >
                                <Button>멘토 피드백</Button>
                              </Link>
                            ) : (
                              <>
                                {get(mentoring_class, 'feedback') ? (
                                  <Link
                                    to={`${ERoute.MentoringFeedback}/edit/${get(
                                      mentoring_class,
                                      'feedback',
                                    )}?id=${get(mentoring_class, 'id')}`}
                                  >
                                    <Button type='primary'>피드백 수정</Button>
                                  </Link>
                                ) : (
                                  <Link
                                    to={`${ERoute.MentoringFeedback}/create/?id=${get(
                                      mentoring_class,
                                      'id',
                                    )}`}
                                  >
                                    <Button type='primary'>피드백 쓰기</Button>
                                  </Link>
                                )}
                              </>
                            )}
                          </Col>
                        )}
                        <Col>
                          <Link
                            to={`${ERoute.MentoringClassView.replace(
                              ':record_id',
                              String(get(mentoring_class, 'id')),
                            )}`}
                          >
                            <Button>자세히 보기</Button>
                          </Link>
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>
                {useDivider === true ? (
                  <Divider className='class-divider' />
                ) : (
                  <div style={{ height: '15px' }}></div>
                )}
              </>
            )}
          />
        </Spin>
      </div>
      <BackTop></BackTop>
      {get(data, 'total') > 0 && !get(data, 'last') ? (
        <Button
          onClick={() => {
            reloadPage({
              current: get(pagination, 'current', 1) + 1,
              pageSize: pagination.pageSize,
            });
          }}
          style={{ margin: '0px auto', display: 'block' }}
        >
          더보기
        </Button>
      ) : (
        <div></div>
      )}
      <MentoringReviewModal modalState={mentoringReviewModal} setModalState={setMentoringReviewModal} />
    </>
  );
};

export default MentoringPastClass;
